import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-8" }
const _hoisted_2 = { key: 2 }

import { ref, onMounted } from 'vue';

import fetchAllOrders from '@/service/order.service';
import ErrorMessage from '@/components/admin-dashboard/ErrorMessage.vue';
import LoadingSpinner from '@/components/admin-dashboard/LoadingSpinner.vue';
import OrderCard from '@/components/admin-dashboard/OrderCard.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrdersDashboard',
  setup(__props) {

const orders = ref([]);
const loading = ref(true);
const error = ref('');

onMounted(async () => {
  try {
    const result = await fetchAllOrders();
    orders.value = result;
  } catch (err: any) {
    error.value = err.message || 'Failed to load orders';
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "text-2xl font-bold text-[#C59C2F] mb-6" }, "All House Cleaning Orders", -1)),
    (loading.value)
      ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
      : (error.value)
        ? (_openBlock(), _createBlock(ErrorMessage, {
            key: 1,
            message: error.value
          }, null, 8, ["message"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orders.value, (order) => {
              return (_openBlock(), _createBlock(OrderCard, {
                key: order.id,
                order: order
              }, null, 8, ["order"]))
            }), 128))
          ]))
  ]))
}
}

})